function requestUrlFunction(params, addPageParams = true) {
  let requestUrl = '';
  if (params.filterParams) {
    Object.entries(params.filterParams).forEach(([key, value]) => {
      if (requestUrl.length === 0) {
        requestUrl = '?';
      } else {
        requestUrl += '&';
      }
      requestUrl += `${key}=${encodeURIComponent(value)}`;
    });
  }
  if (params.options) {
    if (params.options.sortBy && params.options.sortBy.length) {
      const sort = params.options.sortBy ? `${params.options.sortBy},${params.options.sortDesc[0] ? 'desc' : 'asc'}` : '';
      if (requestUrl.length === 0) {
        requestUrl = '?';
      } else {
        requestUrl += '&';
      }
      requestUrl += `sort=${sort}`;
    }
    if (addPageParams) {
      if (params.options.page) {
        if (requestUrl.length === 0) {
          requestUrl = '?';
        } else {
          requestUrl += '&';
        }
        requestUrl += `page=${params.options.page}`;
      }
      if (params.options.itemsPerPage) {
        if (requestUrl.length === 0) {
          requestUrl = '?';
        } else {
          requestUrl += '&';
        }
        requestUrl += `size=${params.options.itemsPerPage}`;
      }
    }
  }

  return requestUrl;
}

export default requestUrlFunction;
